import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { VehicleDeliveryHeaderContainerModel } from '../../../../../../../models/aggregates/erp/delivery/vehicle/vehicle-hdr-container.model';



@Injectable({
  providedIn: 'root'
})
export class VehicleHdrService extends BaseApiTemplateService<VehicleDeliveryHeaderContainerModel> {
    // https://api-test.akaun.com/core2/tnt/dm/del/vehicles
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/vehicles';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/vehicles';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/vehicles';
    this.httpClient = http;
  }
}
